import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-mis',
    templateUrl: './mis.component.html',
    styleUrls: ['./mis.component.css']
})
export class MisComponent implements OnInit {
    
    //for disabling div  in production
    constructor(private router: Router, private _location: Location) {
     
    }

    ngOnInit() {
       
    }

   

}